import { ApiServiceImpl } from "../core/api.service.impl";
import { MessageType, ChatMessage, } from "../../models";
import { safeAccountIdToChannelId } from "../../utils";
export class GnoSafeSenderServiceImpl extends ApiServiceImpl {
    constructor(chatService, signerService) {
        super();
        this.chatService = chatService;
        this.signerService = signerService;
    }
    async proposeMessage(safe, content) {
        try {
            const channelId = safeAccountIdToChannelId(safe);
            // Create message payload
            const payload = {
                id: crypto.randomUUID(),
                type: MessageType.MESSAGE,
                from: safe.toString(),
                // TODO: Add to field
                body: {
                    content: content,
                },
            };
            const requestMessage = await this.signAndSendMessageRequest(payload, channelId);
            if (requestMessage.data) {
                return this.success(requestMessage.data);
            }
            else {
                return this.error(requestMessage.error);
            }
        }
        catch (e) {
            return this.error(e);
        }
    }
    async approveMessage(safe, messageRequest) {
        try {
            const channelId = safeAccountIdToChannelId(safe);
            const payload = {
                id: messageRequest.body.id,
                type: MessageType.MESSAGE,
                from: messageRequest.body.message.from,
                body: messageRequest.body.message.body.getDto(),
            };
            const newRequest = await this.signAndSendMessageRequest(payload, channelId);
            if (!newRequest.data) {
                return this.error(newRequest.error);
            }
            return this.success(newRequest.data);
        }
        catch (e) {
            return this.error(e);
        }
    }
    async sendMessage(channelId, messageRequests) {
        try {
            if (messageRequests.length == 0) {
                throw new Error("Must have at least one message request");
            }
            const payload = this.signerService.combineMessageRequests(messageRequests);
            const sendMessageResult = await this.chatService.sendRaw(payload, channelId);
            if (!sendMessageResult.data) {
                throw sendMessageResult.error;
            }
            const chatMessage = new ChatMessage({
                ...messageRequests[0].body.message.getDto(),
                ...sendMessageResult.data,
            });
            return this.success(chatMessage);
        }
        catch (e) {
            return this.error(e);
        }
    }
    async signAndSendMessageRequest(payload, channelId) {
        try {
            // Sign message
            const signedMessageResult = await this.signerService.signMessage(payload);
            if (!signedMessageResult.data) {
                throw signedMessageResult.error;
            }
            const signedMessage = signedMessageResult.data;
            // Send signed message to signers' channel
            const sendMessageResult = await this.chatService.send({ type: MessageType.SIGNATURE_REQUEST, body: signedMessage }, channelId);
            if (!sendMessageResult.data) {
                throw sendMessageResult.error;
            }
            return this.success(sendMessageResult.data);
        }
        catch (e) {
            return this.error(e);
        }
    }
}
